<div class="materials-banner-wrapper materials-banner-wrapper--loader">
  <ngx-skeleton-loader
    [theme]="{
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: '0',
      left: '0',
      'margin-bottom': '0',
      'background-color': '#dfe1e6',
    }"
  ></ngx-skeleton-loader>
  <div class="materials-banner-image">
    <div class="materials-banner-icon materials-banner-icon--loader">
      <ngx-skeleton-loader
        count="1"
        appearance="circle"
        [theme]="{
          width: '100%',
          height: '100%',
          margin: '0',
          'border-radius': '0',
        }"
      >
      </ngx-skeleton-loader>
    </div>
    <div class="image-loader">
      <ngx-skeleton-loader
        count="1"
        appearance="circle"
        [theme]="{
          width: '100%',
          height: '100%',
          margin: '0',
          'border-radius': '0',
          'background-color': '#f9f9fa',
        }"
      >
      </ngx-skeleton-loader>
    </div>
  </div>
  <div class="content-loader">
    <ngx-skeleton-loader
      [theme]="{
        width: '100%',
        height: '100%',
        margin: '0',
      }"
    >
    </ngx-skeleton-loader>
  </div>
</div>
